// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","continue":"Buttons_continue__2nEao","back":"Buttons_back__1bI4J","navButtons":"Buttons_navButtons__pcseJ"};